export const env = {
  liffId: import.meta.env.VITE_LIFF_ID,
  shopSlug: import.meta.env.VITE_SHOP_SLUG,
  apiBaseUrl: import.meta.env.VITE_API_BASE_URL,
};

if (!env.liffId || !env.shopSlug || !env.apiBaseUrl) {
  throw new Error("missing required env: VITE_LIFF_ID / VITE_SHOP_SLUG / VITE_API_BASE_URL");
}
